import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { ActionCreators as UndoActionCreators } from 'redux-undo'
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import "./Create.css";
import { setupNavigation } from "../../redux/actions/navItemsActions"
import 'leaflet/dist/leaflet.css'
import CheckboxInput from "../common/formfields/CheckboxInput"
import Spinner from "../common/Spinner";
import { getDistanceBetweenPoints, getElevation, standardisePoint, directionRequestWithinCoverage } from "../../api/routeUtilitiesApi";
import { GDIR_ACTIVE } from "../../api/config";
import CreateRouteOsmMapView from "./CreateRouteOsmMapView";
import CreateRouteGoogleMapView from "./CreateRouteGoogleMapView";
import CreateRouteBingMapView from "./CreateRouteBingMapView";
import UploadRouteControl from "./UploadRouteControl";
import MapSwitchControl from "./MapSwitchControl";
import RouteForm from "./RouteForm";
import { setReCentreOnMapLoad, updateDraftRouteMapCentre, updateDraftRouteMapZoom, saveDraftRoute, clearDraftRoute, addDraftRouteMapPoints, updateDraftRouteMapType, updateDraftRoutePlotMode, updateDraftRouteAutoMode, updateDraftRouteCreateMode, undoDraftRoute, redoDraftRoute, deleteDraftRouteMapPoint, moveDraftRouteMapPoint, insertDraftRouteMapPoint, clearRoute } from "../../redux/actions/routeActions";
import { UTMConvert } from "../../api/utm";
import $ from 'jquery';
import 'bootstrap/js/dist/modal.js';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { toast } from "react-toastify";
import { Helmet } from 'react-helmet';


function CreateRoutePage({
    user,
    setupNavigation,
    routeCreatorState,
    draftRoute,
    updateDraftRouteMapType,
    updateDraftRouteMapZoom,
    updateDraftRouteMapCentre,
    addDraftRouteMapPoints,
    deleteDraftRouteMapPoint,
    moveDraftRouteMapPoint,
    insertDraftRouteMapPoint,
    updateDraftRoutePlotMode,
    updateDraftRouteAutoMode,
    updateDraftRouteCreateMode,
    setReCentreOnMapLoad,
    undoDraftRoute,
    redoDraftRoute,
    saveDraftRoute,
    clearDraftRoute,
    clearRoute,
    history
}) {

    const [routeDetails, setRouteDetails] = useState({ name: "", category: "", description: "", private: false });
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);
    const [totalDistance, setTotalDistance] = useState(0);
    const [totalElevation, setTotalElevation] = useState(0);
    const [elevationData, setElevationData] = useState([]);
    const [showAutoMode, setShowAutoMode] = useState(true);
    const [showAutoOption, setShowAutoOption] = useState(true);
    const [useGDirections, setUseGDirections] = useState(GDIR_ACTIVE);
    
    const navigationItems = { sections: [] };
    const chartRef = useRef(null);
   

    const chartOptions =
        {
            chart: {
                type: 'areaspline',
                backgroundColor: 'rgba(255, 255, 255, 0)',
                spacingBottom: 0,
                spacingTop: 30,
                spacingLeft: 0,
                height: 120
            },
            title: {
                text: '',
                style: { color: '#888888' }
            },
            xAxis: {
                gridLineColor: '#888888',
                lineColor: '#888888',
                tickColor: '#888888',
                title: {
                    text: user.preferredMeasurementUnits === 'Statute' ? 'Distance(mi)' : 'Distance(km)',
                    style: { color: '#888888', fontWeight: 'normal' }
                },
                labels: {
                    formatter: function () {
                        return this.value; // clean, unformatted number for year
                    },
                    style: { color: '#888888' }
                }
            },
            yAxis: {
                gridLineColor: '#888888',
                lineColor: '#888888',
                tickColor: '#888888',
                title: {
                    text: user.preferredMeasurementUnits === 'Statute' ? 'Elevation(ft)' : 'Elevation(m)',
                    style: { color: '#888888', fontWeight: 'normal' }
                },
                labels: {
                    formatter: function () {
                        return this.value; // clean, unformatted number for year
                    },
                    style: { color: '#888888' }
                }
            },
            tooltip: {
                enabled: true,
                headerFormat: '',
                pointFormat: 'Elevation: <b>{point.y}</b> ' +
                    (user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm') +
                            '<br/>Distance: <b>{point.x}</b> ' +
                    (user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km')
            },
            plotOptions: {
                areaspline: {
                    color: '#14a4ff',
                    marker: {
                        enabled: false,
                        fillColor: '#14A4FF',
                        lineColor: '#888888',
                        lineWidth: 2,
                        radius: 4,
                        states: {
                            over: {
                                enabled: true,
                                fillColor: '#14A4FF',
                                lineColor: '#888888',
                                lineWidth: 2,
                                radius: 4
                            },
                            select: {
                                enabled: true,
                                fillColor: '#14A4FF',
                                lineColor: '#888888',
                                lineWidth: 2,
                                radius: 4
                            }
                        }
                    },
                    fillOpacity: 0.5
                }
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            series: getElevationChartData()
        }


    useEffect(() => {
        document.title = "Create a GPX Cycle Route | JustGoRide"

        if (!routeCreatorState|| !routeCreatorState.mapType) {
            updateDraftRouteMapType({ type: "OSM", variant: "OSM"})
        }

        if (!routeCreatorState || !routeCreatorState.centre) {
            if (navigator.geolocation) {
                setProcessing(true);
                const options = {
                    timeout: 5000
                };
                navigator.geolocation.getCurrentPosition(setBrowserLocation, setDefaultLocation, options);

            } else {
                setDefaultLocation(); 
            }
        } 
        setupNavigation(navigationItems);

    }, []);

    useEffect(() => {
        
        var distance = 0;
        var lastlon;
        var lastlat;

        if (draftRoute.present) {
            draftRoute.present.map((point, index) => {
                var lon = point.lng;
                var lat = point.lat;

                var lastTrackpointPosition = UTMConvert(lastlon, lastlat);
                var currentTrackpointPosition = UTMConvert(lon, lat);
                var pointDistance = Math.sqrt(((currentTrackpointPosition.X - lastTrackpointPosition.X) * (currentTrackpointPosition.X - lastTrackpointPosition.X)) + ((currentTrackpointPosition.Y - lastTrackpointPosition.Y) * (currentTrackpointPosition.Y - lastTrackpointPosition.Y)));

                if (pointDistance < 100000) {
                    distance += pointDistance;
                }
                lastlon = lon;
                lastlat = lat;
                point.dist = distance;
            })

            distance = distance / 1000;
            if (user.preferredMeasurementUnits == 'Statute') {
                distance = distance * 0.621371192;
            }
            setTotalDistance(Math.round(distance * Math.pow(10, 2)) / Math.pow(10, 2));

            updateElevation();
        }
        

    }, [draftRoute])

    function setDefaultLocation() {
        updateDraftRouteMapCentre([52.912454, -1.446462]);
        updateDraftRouteMapZoom(14);
        setProcessing(false);
    }

    function setBrowserLocation(position) {
        updateDraftRouteMapCentre([position.coords.latitude, position.coords.longitude])
        updateDraftRouteMapZoom(14)
        //prime elevation service
        getElevation([{ lat: position.coords.latitude, lng: position.coords.longitude }])
            .then(results => {
            results.map(() => {
                console.log(`Elevation Primed`);
            })
        })
        setProcessing(false);
    }

    function onMapLoad() {
    }

    function onAddRoutePoints(points){
        addDraftRouteMapPoints(points);
    }

    function onDeleteRoutePoint(index) {
        deleteDraftRouteMapPoint(index);
    }

    function onMoveRoutePoint(point, index) {
        moveDraftRouteMapPoint(point, index);
    }

    function onInsertRoutePoint(point, index) {
        insertDraftRouteMapPoint(point, index);
    }

    function onMapUpdated(mapProps) {
        if (mapProps.centre) {
            updateDraftRouteMapCentre(mapProps.centre);
            if (mapProps.reprimeZoom) {
                getElevation([{ lat: mapProps.centre.lat, lng: mapProps.centre.lng }])
                    .then(results => {
                        results.map(() => {
                            console.log(`Elevation reprimed on center reposition.`);
                        })
                    })
            }
            /*Check if centre in directions service coverage if Google directions switched off..*/
            var centre = { lat: mapProps.centre[0], lng: mapProps.centre[1] }
            if (!directionRequestWithinCoverage(centre, centre) && !useGDirections) {
                setShowAutoOption(false);
                setShowAutoMode(false);
            } else {
                setShowAutoOption(true);
                setShowAutoMode(true);
            }
            
        }
        if (mapProps.zoom) {
            updateDraftRouteMapZoom(mapProps.zoom);
        }
        if (mapProps.mapType) {
            updateDraftRouteMapType(mapProps.mapType);
        }
        if (mapProps.createMode) {
            updateDraftRouteCreateMode(mapProps.createMode);
        }
        if (mapProps.plotMode) {
            updateDraftRoutePlotMode(mapProps.plotMode); 
        }

        if (mapProps.autoMode) {
            updateDraftRouteAutoMode(mapProps.autoMode);
        }
    }

    function onChangePlotMode(e) {
        var mode = routeCreatorState.plotMode == "auto" ? "manual" : "auto"; 
        setShowAutoMode(e.target.checked)
        updateDraftRoutePlotMode(mode); 
    }

    function onChangeAutoMode() {
        var mode = routeCreatorState.autoMode == "bike" ? "foot" : "bike";
        updateDraftRouteAutoMode(mode);
    }

    function onSetDrawMode() {
        updateDraftRouteCreateMode("draw");
    }

    function onSetEditMode() {
        updateDraftRouteCreateMode("edit");
    }

    function onUndo(){
        undoDraftRoute()
    }

    function onRedo() {
        redoDraftRoute()
    }

    function onClear() {
        clearDraftRoute()
        var mode = routeCreatorState.plotMode == "auto" ? "manual" : "auto";
        updateDraftRoutePlotMode(mode); 
        $('#confirmClearRoute').modal('hide')
    }

    function onUpload(route) {
        $('#uploadRoute').modal('hide')
        clearDraftRoute();
        addDraftRouteMapPoints(route);
        setReCentreOnMapLoad(true); 
        var mode = routeCreatorState.plotMode == "auto" ? "manual" : "auto";
        updateDraftRoutePlotMode(mode);
    }

    function onCancelUpload() {
        $('#uploadRoute').modal('hide')
    }

    function onSetReCentreOnLoad(value) {
        setReCentreOnMapLoad(value); 
    }

    function onSave(event) {
        event.preventDefault();

        if (!formIsValid()) return;

        $('#saveRoute').modal('hide');
        setProcessing(true);

        draftRoute.details = routeDetails;

        //finalise Elevation -
        updateElevation(true);
    }

    function openSaveModal(e) {
        e.preventDefault();

        if (!user || !user.id) {
            history.push("/login?rtn=/routes/create");
            return;
        }

        $('#saveRoute').modal('show');
    }

    function submitSave() {
        //finally go save!

        if (routeCreatorState.routeId) {
            draftRoute.routeId = routeCreatorState.routeId;
        }

        saveDraftRoute(draftRoute)
        .then((routeId) => {
            clearRoute(); 
            setProcessing(false);
            toast.success("Route Saved!");
            history.push(`/routes/${routeId}`);
        })
        .catch(error => {
            setProcessing(false);
            setErrors({ onSave: error.message });
        });
    }

    function onCancelSave() {
        $('#saveRoute').modal('hide')
    }

    function handleChange(event) {
        var { name, value } = event.target;
        if (name === "publish") {
            name = "private";
            value = !event.target.checked;
        }
        setRouteDetails(prevRouteDetails => ({
            ...prevRouteDetails,
            [name]: value
        }));
    }

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!routeDetails.name) {
            errors.name = "A route name is required.";
            setErrors(errors);
            isValid = false;
        }

        if (routeDetails.category != "Road" && routeDetails.category != "OffRoad" && routeDetails.category != "Gravel") {
            errors.category = "Please select a category.";
            setErrors(errors);
            isValid = false;
        }

        return isValid;
    }

    //Method for gathering elevation for points where missing

    function onUpdateElevation() {
        updateElevation(false);
    }

    function updateElevation(savingRoute) {

        var pointsToElevate = [];

        draftRoute.present.map(point => {
            if (point.ele === 0 || point.ele === undefined || point.ele === null) {
                pointsToElevate.push(point);
            }
        }); 

        if (pointsToElevate.length === 0) {
            if (savingRoute) {
                submitSave();
                return;
            }
            updateElevationChart();
            return; 
        }

        getElevation(pointsToElevate).then(results => {
            results.map(result => {
                draftRoute.present.map(point => {
                    if (point.lat == result.lat && point.lng == result.lng) {
                        point.ele = result.ele;
                    }
                });
                if (savingRoute) {
                    submitSave();
                    return;
                }
            })
            updateElevationChart();
        })
    }
    //Set Interval Timer!
    //var elevationTimer = setInterval(onUpdateElevation.bind(this), 20000);


    function updateElevationChart() {

        var elevationdata = [];
        var lastvalidelevation = 0;
        var totalelevationgain = 0;

        draftRoute.present.map((point, idx) => {
            if (idx == 0) {
                point.dist = 0;
            }
            else {
                var prevpoint = draftRoute.present[idx - 1];
                var pointDistance = getDistanceBetweenPoints(prevpoint, point);
                point.dist = prevpoint.dist + pointDistance;
            }
           
            var chartelevation = point.ele;
            //iron out any missing elevation points
            if (chartelevation == 0) {
                chartelevation = lastvalidelevation;
            }
            else {
                //calc total elevation within tolerance
                if (idx > 0) {
                    var elevationchange = chartelevation - lastvalidelevation;
                    if (elevationchange > 1) {
                        totalelevationgain += elevationchange;
                    }
                }
                if (chartelevation - lastvalidelevation > 1 || chartelevation - lastvalidelevation < -1) {
                    lastvalidelevation = chartelevation;
                }
            }
            var chartdistance = point.dist / 1000;

            if (user.preferredMeasurementUnits == 'Statute') {
                chartdistance = chartdistance * 0.621371192;
                chartelevation = chartelevation * 3.2808399;
            }

            elevationdata.push([Math.round(chartdistance * Math.pow(10, 2)) / Math.pow(10, 2), Math.round(chartelevation * Math.pow(10, 2)) / Math.pow(10, 2)]);
        })

        //record total elevation
       
        if (user.preferredMeasurementUnits == 'Statute') {
            totalelevationgain = totalelevationgain * 3.2808399;
        }

        totalelevationgain = Math.round(totalelevationgain * Math.pow(10, 2)) / Math.pow(10, 2);

        setTotalElevation(totalelevationgain);
        setElevationData(elevationdata); 
        
    };

    function getElevationChartData() {
        return [{
            id: "elevationdata",
            data: elevationData,
            turboThreshold: 4000
        }];
    }

    function handleMapTypeChanged(type) {
        onMapUpdated({ mapType: type })
    }

    function redirectToSignUp(e) {
        e.preventDefault(); 
        $('#signUpModal').modal('hide');
        history.push('/signup');
    }

    return (
        <React.Fragment>
            {
                processing ?
                    <Spinner /> : (
                        <React.Fragment>
                            <Helmet>
                                <meta name="title" content="JustGoRide GPX Cycling Route Creator" />
                                <meta name="description" content="Create your own GPX cyle route with the JustGoRide Route Creator. This tool enables you to plot your own GPX bike route, save and download it to any GPX supporting GPS device. The GPX cycle route plotting tool makes it easy to plot your own bike route and explore the countryside. The GPX cycle route plotting tool supports Open Street Maps, Google Maps, Bing Maps and Ordanance Survey Maps." />
                                <meta name="keywords" content="mountain bike, mountain biking, road bike, road biking, cyclocross, gravel bike, gravel biking, commuting, cycling, bicycle, cycle route plotting, bike route plotting, GPX route plotting, route plotting creation tool, google maps bike route, open street maps bike route, ordanance survey maps bike routes, bing maps bike route" />
                            </Helmet>
                            <div className="create-map-container-outer">
                                <MapSwitchControl mapChanged={handleMapTypeChanged} mapType={routeCreatorState.mapType ? routeCreatorState.mapType.variant : null} /> 
                                {routeCreatorState.mapType && routeCreatorState.mapType.type == "GOOGLE" &&
                                    <CreateRouteGoogleMapView
                                        centre={routeCreatorState.centre}
                                        zoom={routeCreatorState.zoom}
                                        points={draftRoute.present}
                                        mapVariant={routeCreatorState.mapType ? routeCreatorState.mapType.variant : null}
                                        mapUpdated={onMapUpdated}
                                        addRoutePoints={onAddRoutePoints}
                                        deleteRoutePoint={onDeleteRoutePoint}
                                        moveRoutePoint={onMoveRoutePoint}
                                        insertRoutePoint={onInsertRoutePoint}
                                        setReCentreOnLoad={onSetReCentreOnLoad}
                                    />
                                }
                                {routeCreatorState.mapType && routeCreatorState.mapType.type == "OSM" &&
                                    <CreateRouteOsmMapView
                                        centre={routeCreatorState.centre}
                                        zoom={routeCreatorState.zoom}
                                        points={draftRoute.present}
                                        mapVariant={routeCreatorState.mapType ? routeCreatorState.mapType.variant : null}
                                        mapUpdated={onMapUpdated}
                                        addRoutePoints={onAddRoutePoints}
                                        deleteRoutePoint={onDeleteRoutePoint}
                                        moveRoutePoint={onMoveRoutePoint}
                                        insertRoutePoint={onInsertRoutePoint}
                                        onChangePlotMode={onChangePlotMode}
                                        setReCentreOnLoad={onSetReCentreOnLoad}
                                    />
                                }
                                {routeCreatorState.mapType && routeCreatorState.mapType.type == "BING" &&
                                    <CreateRouteBingMapView
                                        centre={routeCreatorState.centre}
                                        zoom={routeCreatorState.zoom}
                                        points={draftRoute.present}
                                        mapVariant={routeCreatorState.mapType ? routeCreatorState.mapType.variant : null}
                                        mapUpdated={onMapUpdated}
                                        addRoutePoints={onAddRoutePoints}
                                        deleteRoutePoint={onDeleteRoutePoint}
                                        moveRoutePoint={onMoveRoutePoint}
                                        insertRoutePoint={onInsertRoutePoint}
                                        onChangePlotMode={onChangePlotMode}
                                        setReCentreOnLoad={onSetReCentreOnLoad}
                                    />
                                }
                                {!user || !user.id &&
                                    <div className="alert alert-sign-up sign-up-warning">
                                        In order to save and download your route you will need to be <Link to="/login?rtn=/routes/create">logged in</Link>.
                                        If you don't have an account you can <Link to="/signup">sign up here</Link>!
                                    </div>
                                }
                            </div>
                            <div className="creator-controls">
                                <div className="creator-btns">
                                    <button title="create" className={routeCreatorState.createMode == "draw" ? "btn btn-info" : "btn btn-secondary"} onClick={onSetDrawMode} ><span className="fas fa-pencil-alt" /></button>
                                    <button title="edit" className={routeCreatorState.createMode == "edit" ? "btn btn-info ml-1" : "btn btn-secondary ml-1"} onClick={onSetEditMode} ><span className="fas fa-hand-pointer" /></button>
                                    <button title="undo" className="btn btn-secondary ml-3" onClick={onUndo} disabled={!(draftRoute.past.length > 0)}><span className="fas fa-undo-alt" /></button>
                                    <button title="redo" className="btn btn-secondary ml-1" onClick={onRedo} disabled={!(draftRoute.future.length > 0)}><span className="fas fa-redo-alt" /></button>
                                    <button title="clear" className="btn btn-secondary ml-1" data-toggle="modal" data-target="#confirmClearRoute" disabled={!(draftRoute.present.length > 0)}><span className="fas fa-trash-alt" /></button>
                                    <button title="upload" className="btn btn-secondary ml-1" data-toggle="modal" data-target="#uploadRoute" ><span className="fas fa-file-upload" /></button>
                                    {routeCreatorState.routeId
                                        ?
                                        <button title="save" className="btn btn-success ml-1" onClick={submitSave} disabled={!(draftRoute.present.length > 0)} ><span className="fas fa-save" /></button>
                                        :
                                        <button title="save" className="btn btn-success ml-1" onClick={openSaveModal} disabled={!(draftRoute.present.length > 0)} ><span className="fas fa-save" /></button>
                                    }
                                </div>
                                {showAutoOption &&
                                    <div className="creator-auto">
                                        <CheckboxInput
                                            name="autoPlottingToggle"
                                            label="Auto Plotting"
                                            checked={routeCreatorState.plotMode == "auto"}
                                            onChange={onChangePlotMode}
                                            value={routeCreatorState.plotMode == "auto"}
                                        />
                                    </div>
                                }
                                {showAutoMode &&
                                    <div className="auto-mode d-none d-sm-inline-block">
                                        <label className={routeCreatorState.autoMode == "bike" ? "auto-icon active" : "auto-icon"}><span className="fal fa-biking"></span></label>
                                        <label className="switch">
                                            <input type="checkbox" onChange={onChangeAutoMode} value={routeCreatorState.autoMode != "bike"} checked={routeCreatorState.autoMode != "bike"}/>
                                            <span className="slider round"></span>
                                        </label>
                                        <label className={routeCreatorState.autoMode == "foot" ? "auto-icon active" : "auto-icon"}><span className="fal fa-hiking"></span></label>
                                    </div>
                                }
                                <div className="help">
                                    <div data-toggle="modal" data-target="#help-modal"><i className="far fa-question-circle"></i> Help</div>
                                </div>
                            </div>
                            <div className="route-data">
                                <div className="vitals">
                                    <div className="data">
                                        <div className="data-head">Distance</div>
                                        <div className="data-body">{totalDistance.toFixed(1)}</div>
                                        <div className="data-footer">{user.preferredMeasurementUnits == 'Statute' ? 'miles' : 'kilometres'}</div>
                                    </div>
                                    <div className="data">
                                        <div className="data-head">Elevation</div>
                                        <div className="data-body">{totalElevation.toFixed(0)}</div>
                                        <div className="data-footer">{user.preferredMeasurementUnits == 'Statute' ? 'feet' : 'metres'}</div>
                                    </div>
                                </div>
                                <div className="elevation-outer">
                                    <div className="elevation-inner">
                                        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} />
                                    </div>
                                </div>
                            </div>

                            <div className="route-data-status-bar">
                                <span>Distance: <em>{totalDistance.toFixed(1)}</em> {user.preferredMeasurementUnits == 'Statute' ? 'mi' : 'km'}</span>
                                <span> <em>|</em> Elevation: <em>{totalElevation.toFixed(0)}</em> {user.preferredMeasurementUnits == 'Statute' ? 'ft' : 'm'}</span>
                            </div>

                            <div className="modal fade" id="confirmClearRoute" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                            <h5 className="modal-title" >Clear Route?</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Are you sure that you want to clear the map and start again? 
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-link" data-dismiss="modal">Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={onClear}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="uploadRoute" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                            <h5 className="modal-title">Upload Route</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <UploadRouteControl onCancel={onCancelUpload} onUpload={onUpload} warningMessage="Uploading a new route will clear any existing draft route."/> 
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="saveRoute" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                            <h5 className="modal-title">Save Route</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <RouteForm
                                                route={routeDetails}
                                                errors={errors}
                                                onChange={handleChange}
                                                onSave={onSave}
                                                onCancel={onCancelSave}
                                                processing={processing}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="signUpModal" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                            <h5 className="modal-title" >Pick up where you left off!</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            Once you have signed up and activated your account, click on the 'Create' link in
                                            the nav bar at the top of the page to pick up where you left off with your route!
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-link" data-dismiss="modal">Cancel</button>
                                            <button type="button" className="btn btn-info" onClick={redirectToSignUp}>Sign Up</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="help-modal" tabIndex="-1" role="dialog" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                                            <h5 className="modal-title" >Help</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <h3>Key Functions</h3>
                                            <ul className="help-key">
                                                <li>
                                                    <button className="btn btn-info help-key-icon"><span className="fas fa-pencil-alt" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Draw</strong><br/>
                                                        One of the main tools, the draw function allows you to plot new points onto the
                                                        map. Every time a new point is plotted a line is drawn to link the two points. You
                                                        can also move the points around by clicking and dragging them.
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-info help-key-icon"><span className="fas fa-hand-pointer" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Edit</strong><br />
                                                        This function turns off the ability to plot new points in order to focus
                                                        on refining the route further. Move or delete existing points by clicking on
                                                        them and also add points by clicking on the route line between existing points.
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-secondary help-key-icon"><span className="fas fa-undo-alt" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Undo</strong><br />
                                                        The undo function works exactly how you would expect it to. Each time you make a
                                                        change to your route it is logged enabling you to undo the last 10 actions
                                                        performed on your route.
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-secondary help-key-icon"><span className="fas fa-redo-alt" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Redo</strong><br />
                                                        Undone something by mistake? Then redo it by clicking here! This function will allow you to redo the last 10 actions
                                                        performed on your route.  
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-secondary help-key-icon"><span className="fas fa-trash-alt" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Clear Route</strong><br />
                                                        If everything is all wrong and you just can't cope anymore, use this function to 
                                                        reset the map and clear the route so that you can start a fresh!
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-secondary help-key-icon"><span className="fas fa-file-upload" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Upload and Edit</strong><br />
                                                        Already have a route GPX file that isn't quite right? Use this function to upload it into the 
                                                        creator and adapt the route to suit your needs before saving it!
                                                    </div>
                                                </li>
                                                <li>
                                                    <button className="btn btn-success help-key-icon"><span className="fas fa-save" /></button>
                                                    <div className="help-key-description">
                                                        <strong>Save</strong><br />
                                                        Once your creation is complete, you can save it to the site by using the save function.
                                                        This will ask you to name your route and give a brief description.
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="auto-mode help-key-icon">
                                                        <label className="auto-icon active"><span className="fal fa-biking"></span></label>
                                                        <label className="switch">
                                                            <input type="checkbox" onChange={() => { }} value={routeCreatorState.autoMode != "bike"} checked={routeCreatorState.autoMode != "bike"} />
                                                            <span className="slider round"></span>
                                                        </label>
                                                        <label className="auto-icon"><span className="fal fa-hiking"></span></label>
                                                    </div>
                                                    <div className="help-key-description">
                                                        <strong>Auto Plotting</strong><br />
                                                        This function allows an auto plotting feature that fills in the points between map clicks to follow roads
                                                        and trails. The mode switch allows you to change between hiking and biking modes. Please ensure that any
                                                        footpaths included in a route are called out in the description and common sense is practised when riding
                                                        such routes to ensure you dismount where necessary. 
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-info" data-dismiss="modal">OK</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </React.Fragment>
                    )
            }
        </React.Fragment>
    );

}

CreateRoutePage.propTypes =
    {
        user: PropTypes.object.isRequired,
        setupNavigation: PropTypes.func.isRequired,
        routeCreatorState: PropTypes.object,
        draftRoute: PropTypes.object.isRequired,
        route: PropTypes.object,
        updateDraftRouteMapType: PropTypes.func.isRequired,
        updateDraftRouteMapZoom: PropTypes.func.isRequired,
        updateDraftRouteMapCentre: PropTypes.func.isRequired,
        addDraftRouteMapPoints: PropTypes.func.isRequired,
        deleteDraftRouteMapPoint: PropTypes.func.isRequired,
        moveDraftRouteMapPoint: PropTypes.func.isRequired,
        insertDraftRouteMapPoint: PropTypes.func.isRequired,
        updateDraftRoutePlotMode: PropTypes.func.isRequired,
        updateDraftRouteAutoMode: PropTypes.func.isRequired,
        updateDraftRouteCreateMode: PropTypes.func.isRequired,
        setReCentreOnMapLoad: PropTypes.func.isRequired,
        undoDraftRoute: PropTypes.func.isRequired,
        redoDraftRoute: PropTypes.func.isRequired,
        saveDraftRoute: PropTypes.func.isRequired,
        clearDraftRoute: PropTypes.func.isRequired,
        clearRoute: PropTypes.func.isRequired,
        errorMessage: PropTypes.string
    }


function mapStateToProps(state) {
    return {
        user: state.user,
        draftRoute: state.draftRoute,
        routeCreatorState: state.routeCreatorState
    };
}



const mapDispatchToProps = {
    setupNavigation,
    updateDraftRouteMapType,
    updateDraftRouteMapZoom,
    updateDraftRouteMapCentre,
    addDraftRouteMapPoints,
    deleteDraftRouteMapPoint,
    moveDraftRouteMapPoint,
    insertDraftRouteMapPoint,
    updateDraftRoutePlotMode,
    updateDraftRouteAutoMode,
    updateDraftRouteCreateMode,
    setReCentreOnMapLoad,
    saveDraftRoute,
    clearDraftRoute,
    clearRoute,
    undoDraftRoute,
    redoDraftRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateRoutePage); 


// WEBPACK FOOTER //
// ./src/components/routes/CreateRoutePage.js